/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Toast_Saved2Inputs */

const en_coinvestments_draftemail_toast_saved2 = /** @type {(inputs: Coinvestments_Draftemail_Toast_Saved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft saved`)
};

/**
* | output |
* | --- |
* | "Draft saved" |
*
* @param {Coinvestments_Draftemail_Toast_Saved2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_toast_saved2 = /** @type {((inputs?: Coinvestments_Draftemail_Toast_Saved2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Toast_Saved2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_toast_saved2(inputs)
});
export { coinvestments_draftemail_toast_saved2 as "coInvestments_draftEmail_toast_saved" }